import config from '@/util/appConfig'
import EnglishStrings from '@/strings/en'
import FrenchStrings from '@/strings/fr'

import VueI18n from 'vue-i18n'
import Store from '@/store'

function defaultLanguage() {
  return config.DEFAULT_LANG
}

function validLanguage(lang) {
  return config.SUPPORTED_LANGS.indexOf(lang) >= 0
}

// Provide a function to extract the request langauge. We do this
// so that we can infer the language before the router is fully
// initialized when the Vue instance is created.
// All paths in the app should be of the form: https://host/lang/path,
// and we want to extract the lang part.
function getRequestLanguage() {
  const path = window.location.pathname.slice(1).toLowerCase()
  let lang = path
  const nextSlashPos = path.indexOf('/')
  if (nextSlashPos >= 0) {
    lang = path.slice(0, nextSlashPos)
  }
  return lang
}

function createI18n() {
  let lang = getRequestLanguage()
  if (!lang || !validLanguage(lang)) {
    lang = defaultLanguage()
  } else {
    // Store the lang to make it available to outside modules
    Store.commit('lang', lang)
  }

  let i18n = new VueI18n({
    locale: lang,
    fallbackLocale: defaultLanguage(),
    messages: {
      en: EnglishStrings,
      fr: FrenchStrings
    }
  })

  i18n.currentLanguage = function() {
    return this.locale
  }

  i18n.defaultLanguage = function() {
    return defaultLanguage()
  }

  i18n.validLanguage = function(lang) {
    return validLanguage(lang)
  }

  i18n.oppositeLanguage = function() {
    return (this.locale === 'en' ? 'fr' : 'en')
  }

  i18n.oppositeURL = function() {
    const curLang = this.currentLanguage()
    const oppLang = this.oppositeLanguage()
    // Temporarily pad the url so that the replace function works if the url 
    // doesn't include any path after after the lang, eg. https://server/en
    const curUrl = window.location.href + '/'
    let newUrl = curUrl.replace(`/${curLang}/`, `/${oppLang}/`)
    return newUrl.slice(0, -1)
  }

  return i18n
}

export {
  createI18n,
  validLanguage,
  defaultLanguage,
  getRequestLanguage
}
